import {
  LayoutColor,
  LayoutType,
  LayoutWidth,
  MenuPositions,
  SideBarSize,
  SideBarTheme,
  TopbarTheme,
} from '../config/layout.model';
import { LayoutConfig } from '../models/layout-config.model';
import { MenuItem } from '../models/menu.model';

/**
 * Encontrar todos los padres de un menú seleccionado
 * @param menuItems Lista de menús
 * @param menuItem Menú seleccionado
 * @returns Lista de todos los menús padres del menú seleccionado
 */
const findAllParent = (menuItems: MenuItem[], menuItem: any): any => {
  let parents = [];
  const parent = findMenuItem(menuItems, menuItem['parentKey']);

  if (parent) {
    parents.push(parent['key']);
    if (parent['parentKey'])
      parents = [...parents, ...findAllParent(menuItems, parent)];
  }
  return parents;
};

/**
 * Obtener un elemento del menú
 * @param menuItems Lista de menús
 * @param menuItemKey Clave del menú a buscar
 * @returns Menú que tiene la clave del menú
 */
const findMenuItem = (
  menuItems: MenuItem[] | undefined,
  menuItemKey: string
): any => {
  if (menuItems && menuItemKey) {
    for (let i = 0; i < menuItems.length; i++) {
      if (menuItems[i].key === menuItemKey) {
        return menuItems[i];
      }
      const found = findMenuItem(menuItems[i].children || [], menuItemKey);
      if (found) return found;
    }
  }
  return null;
};

/**
 * Cambiar el atributo de la etiqueta body
 * @param attribute Atributo a cambiar
 * @param value Valor del atributo
 * @param action Acción a realizar
 */
const changeBodyAttribute = (
  attribute: string,
  value?: string,
  action = 'set'
): void => {
  switch (action) {
    case 'remove':
      if (document.body) {
        if (document.body.hasAttribute(attribute)) {
          document.body.removeAttribute(attribute);
        }
      }
      break;
    default:
      if (document.body) document.body.setAttribute(attribute, value!);
      break;
  }
};

/**
 * Devolver configuraciones basadas en el tipo de layout
 * @param layoutType Tipo de layout
 */
const getLayoutConfig = (
  layoutType: LayoutType = LayoutType.LAYOUT_VERTICAL
): LayoutConfig => {
  let config: LayoutConfig = {
    layoutColor: LayoutColor.LAYOUT_COLOR_LIGHT,
    layoutType: layoutType,
    layoutSize: LayoutWidth.LAYOUT_WIDTH_FLUID,
    leftbarPosition: MenuPositions.MENU_POSITION_FIXED,
    leftbarColor: SideBarTheme.LEFT_SIDEBAR_THEME_LIGHT,
    leftbarSize: SideBarSize.LEFT_SIDEBAR_TYPE_DEFAULT,
    topbarColor: TopbarTheme.TOPBAR_THEME_LIGHT,
    showSidebarUserInfo: true,
  };

  switch (layoutType) {
    case LayoutType.LAYOUT_HORIZONTAL:
      return { ...config, topbarColor: TopbarTheme.TOPBAR_THEME_DARK };
    default:
      return config;
  }
};

export { findAllParent, findMenuItem, changeBodyAttribute, getLayoutConfig };
